<template>
  <span v-if="isLoading">
    <v-layout justify-center align-center class="progress-bg">
      <v-progress-circular :size="70" :width="7" color="green" indeterminate />
    </v-layout>
  </span>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState({
      isLoading: state => state.CommonStore.isLoading
    })
  }
};
</script>
<style scoped>
.progress-bg {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.1);
}
</style>